/** Runtime selections are separate from saved filters so incompatible metrics remain visible. */
export function runtimeSlicePayload(filters = {}) {
  const runtime = {}
  for (const selection of Object.values(filters.slice_filters || {})) {
    const ids = selection.value_ids || (selection.value_id ? [selection.value_id] : [])
    if (!ids.length) continue
    if (selection.type === 'campus') runtime.runtime_campus_ids = ids
    else if (selection.partition_type_id) {
      runtime.runtime_partition_filters ||= {}
      runtime.runtime_partition_filters[selection.partition_type_id] = ids
    }
  }
  return runtime
}

export function reportDashboardFilters(filters = {}) {
  const runtime = runtimeSlicePayload(filters)
  return {
    ...(filters.campus_id ? { campus_id: filters.campus_id } : {}),
    ...(runtime.runtime_campus_ids ? { campus_ids: runtime.runtime_campus_ids } : {}),
    partition_filters: { ...(filters.partition_filters || {}), ...(runtime.runtime_partition_filters || {}) },
  }
}

export function sliceFilterKey(selection) {
  return selection?.type === 'campus' ? 'campus_id' : selection?.partition_type_id
}

export function isSliceSelected(selection, filters = {}) {
  const current = filters.slice_filters?.[sliceFilterKey(selection)]
  if (!current) return false
  const values = selection.value_ids || (selection.value_id ? [selection.value_id] : [])
  return JSON.stringify([...values].sort()) === JSON.stringify([...(current.value_ids || [])].sort())
}
